module.exports = __webpack_public_path__ + "img/shequ-7.028c0729.png";